export const getAtrributionsNumber = (ids: (string | null | undefined)[]) =>
  ids.reduce((prev: number, curr) => (curr ? prev + 1 : prev), 0);
